module.exports = __webpack_public_path__ + "media/images/brand-hero-f9d2ff9a003b8abf7920d744ff8307f9.png";